import React from 'react';
import { SelectableFilters, truncateAppliedFilters } from './SelectableFilters';
import { FilterComponentProps } from './types';

export type YesNoNAOption = 'Yes' | 'No' | 'N/A';

type YesNoNAFilterValues = Record<YesNoNAOption, boolean>;

const defaultFilters: YesNoNAFilterValues = { Yes: false, No: false, 'N/A': false };

function renderValues(value: [string, boolean][]): string {
  return truncateAppliedFilters(value.filter(([, applied]) => applied).map(([label]) => label));
}

export const YesNoNAFilters: React.FC<FilterComponentProps> = ({ columnDef, onFilterChanged }) => (
  <SelectableFilters<YesNoNAOption, YesNoNAFilterValues>
    columnDef={columnDef}
    defaultFilters={defaultFilters}
    onFilterChanged={onFilterChanged}
    options={[
      ['Yes', 'Yes'],
      ['No', 'No'],
      ['N/A', 'N/A'],
    ]}
    renderValues={renderValues}
  />
);
